(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cr-eu-shipping-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    const notice = document.getElementById('cr-eu-shipping-notice');
    if (!notice) return;
    const key = 'cr-eu-shipping-paused-v1-dismissed';
    const eu = new Set(['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE']);
    try { if (sessionStorage.getItem(key) === '1') return; } catch {}
    notice.querySelector('button').addEventListener('click', () => {
      notice.hidden = true;
      try { sessionStorage.setItem(key, '1'); } catch {}
    });
    const root = window.Shopify?.routes?.root || '/';
    fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', {
      credentials: 'same-origin',
      signal: AbortSignal.timeout(8000)
    })
      .then(response => response.ok ? response.json() : null)
      .then(data => {
        const country = data?.detected_values?.country?.handle;
        if (typeof country !== 'string' || !eu.has(country.toUpperCase())) return;
        try { if (sessionStorage.getItem(key) === '1') return; } catch {}
        notice.hidden = false;
      })
      .catch(() => {});
  })();
  } catch(e) { console.error(e); }
})();

})();
